import { Skeleton } from '../Skeleton'

interface SkeletonFileListProps {
  count?: number
}

// Mirrors `.st-file-row`: 46px thumb, 14×16 padding, ~70px tall row, 8px gap.
export function SkeletonFileList({ count = 4 }: SkeletonFileListProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {Array.from({ length: count }, (_, i) => (
        <div
          key={i}
          style={{
            border: 'var(--border-w, 2px) solid var(--ink)',
            background: 'var(--paper)',
            boxShadow: 'var(--shadow-sm)',
            padding: '12px 14px',
            display: 'grid',
            gridTemplateColumns: '46px 1fr auto auto',
            gap: 14,
            alignItems: 'center',
            minHeight: 70
          }}>
          <Skeleton.Box w={46} h={46} />
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6, minWidth: 0 }}>
            <Skeleton.Bar w="65%" h={16} />
            <Skeleton.Bar w="35%" h={11} />
          </div>
          <Skeleton.Bar w={56} h={14} />
          <Skeleton.Bar w={22} h={22} />
        </div>
      ))}
    </div>
  )
}
